import { supabase } from '../lib/supabase';
import { getAllBadges } from '../components/badges/badgeDefinitions';

const STORAGE_KEY = 'plangonow_seen_badge_ids_v1';

function readStoredIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

function writeStoredIds(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...new Set(ids)].sort()));
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Po pobraniu statystyk profilu: porównaj zapisane ID odznak z aktualnym zestawem;
 * dla nowych wyślij powiadomienie in-app (RPC create_notification).
 * Przy pierwszym uruchomieniu (brak klucza w localStorage) tylko zapisuje snapshot — bez spamu.
 */
export async function syncBadgeUnlockNotifications({ userId, userRole, stats }) {
  if (!userId || !stats) return;

  const badges = getAllBadges(userRole || 'user', stats, {
    includeRoleBadge: true,
    includeActivityBadges: true,
  });
  const currentIds = badges.map((b) => b.id);

  const previous = readStoredIds();
  if (previous === null) {
    writeStoredIds(currentIds);
    return;
  }

  const prevSet = new Set(previous);
  const newlyUnlocked = badges.filter((b) => !prevSet.has(b.id));
  const merged = new Set(previous);

  for (const badge of newlyUnlocked) {
    try {
      const { error } = await supabase.rpc('create_notification', {
        p_user_id: userId,
        p_type: 'badge_unlocked',
        p_data: {
          badge_id: badge.id,
          badge_label: badge.label,
          badge_label_key: badge.labelKey || null,
          account_user_role: userRole || 'user',
        },
        p_event_id: null,
        p_application_id: null,
      });
      if (error) {
        console.warn('badge_unlocked notification:', error.message || error);
      } else {
        merged.add(badge.id);
      }
    } catch (e) {
      console.warn('badge_unlocked notification failed:', e);
    }
  }

  writeStoredIds(Array.from(merged));
}
